

<app-table-standard-layout [dataSource$]="systems$" [title]="'Systems Information'" [rowActionButtons]="rowActionButtons"
  [columnSettings]="columnSettings"></app-table-standard-layout>